import type { Client } from '@/client';
import type { EifRecord, EnfRecord } from 'eolib';
import { worldResource } from '@/world';

const catalogues = new WeakMap<Client, Promise<Map<number, number>>>();
const requirements = new WeakMap<EifRecord, number>();
function wisdomForNpc(npc: EnfRecord): number {
  if (npc.name.toLowerCase() === 'rat') return 4;
  const strength = Math.floor(Math.max(0,npc.hp)/30) + Math.max(0,npc.maxDamage)
    + Math.floor(Math.max(0,npc.armor)/2) + Math.floor(Math.max(0,npc.experience)/100);
  return Math.max(4, Math.floor(Math.sqrt(strength)*6)-4);
}
export function cachedBookWisdomRequirement(item: EifRecord): number | undefined {
  return requirements.get(item);
}
export function registerBookWisdomRequirements(client: Client, books: {item_id:number; npc_id:number}[]): boolean {
  let changed=false;
  for (const book of books) {
    const item=client.getEifRecordById(book.item_id),npc=client.getEnfRecordById(book.npc_id);
    if(item?.name.startsWith('Book of ')&&npc){const value=wisdomForNpc(npc);if(requirements.get(item)!==value){requirements.set(item,value);changed=true;}}
  }
  return changed;
}
function loadCatalogue(client: Client): Promise<Map<number,number>> {
  let catalogue = catalogues.get(client);
  if (!catalogue) {
    catalogue = fetch(worldResource('/data/SummoningBooks.json'), {cache:'no-store'})
      .then(async response => {
        if (!response.ok) throw new Error('Book catalogue unavailable');
        const data = await response.json();
        return new Map<number, number>((data.books ?? []).map((b: {item_id:number; npc_id:number}) => [b.item_id,b.npc_id]));
      }).catch(error => { catalogues.delete(client); throw error; });
    catalogues.set(client, catalogue);
  }
  return catalogue;
}
export async function preloadBookWisdomRequirements(client: Client): Promise<boolean> {
  const catalogue=await loadCatalogue(client);
  return registerBookWisdomRequirements(client,[...catalogue].map(([item_id,npc_id])=>({item_id,npc_id})));
}
export async function bookWisdomRequirement(client: Client, itemId: number): Promise<number | null> {
  const item=client.getEifRecordById(itemId);
  if (!item?.name.startsWith('Book of ')) return null;
  const cached=requirements.get(item);if(cached!==undefined)return cached;
  const npcId = (await loadCatalogue(client)).get(itemId);
  const npc = npcId ? client.getEnfRecordById(npcId) : null;
  if (!npc) return null;
  const value=wisdomForNpc(npc);requirements.set(item,value);return value;
}
